import React from 'react'

import {makeRequest} from '../http'
import LoginPage from '../page-login'
import useHash from '../utils/use-hash'
// import {useUpdate} from './object-store'
// import {useSaveListener} from './object-store'
// import sorted from './sorted'
import './init-context.scss'


export const InitContext = React.memo(InitContext_)

const InitContextProvider = React.createContext();


function InitContext_({children}) {
    const {hash, setHash} = useHash()
    // const update = useUpdate()

    const [init, setInit] = React.useState(null)
    const [error, setError] = React.useState(null)
    const firstLoadRef = React.useRef(true)

    React.useEffect(() => {
        if (firstLoadRef.current) {
            refresh()
            firstLoadRef.current = false
        }
    }, [hash])

    function refresh() {
        makeRequest('init', {
            body: JSON.stringify({hash: window.location.hash})
        })
            .then(response => {
                const init = response
                setInit(init)
            })
            .catch(error => {
                window.alert(error)
                setError(error)
            })
    }

    if (hash.startsWith('#login')) {
        return <div className="init-context">
            <LoginPage />
        </div>
    }

    if (error) {
        return <div className="init-context">
            <div className="error-page">
                <h1>ERROR</h1>
                <p>
                    <a href="#login" className="a--fresh">Login</a>
                </p>
            </div>
        </div>
    }


    if (!init) {
        return <div className="init-context">
            <span className="spinner spinner--size-1000 spinner--primary" />
        </div>
    }


    return <InitContextProvider.Provider value={{init, setInit}}>
        {children}
    </InitContextProvider.Provider>
}


export function useInit() {
    return React.useContext(InitContextProvider).init
}

export function useWrktsetInit() {
    return React.useContext(InitContextProvider).setInit
}
